var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPodcast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3826 31.6458C33.8659 28.2729 33.6417 20.2291 27.979 17.1669C22.3164 14.1047 15.4623 18.3208 15.6417 24.7559C15.7203 27.5766 17.2161 30.1674 19.6196 31.6458C15.6003 33.2713 12.5563 37.0648 11.7002 41.7145C11.3897 43.4027 12.3556 44.7804 14.0595 44.9947C15.87 45.2226 18.913 45.4285 24.0016 45.4285C29.0903 45.4285 32.1343 45.2226 33.9449 44.9947C35.6477 44.7804 36.6136 43.4027 36.3031 41.7145C35.447 37.0638 32.403 33.2692 28.3826 31.6458Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.04883 23.5553C2.04883 11.8528 11.992 2.57031 24.0008 2.57031C36.0096 2.57031 45.9528 11.8528 45.9528 23.5553C45.9528 26.6642 45.242 29.6214 43.9709 32.2776C43.2276 33.8331 41.2634 34.201 39.8313 33.2424L38.9438 32.6487C37.7396 31.8417 37.449 30.2131 38.024 28.8823C38.7505 27.2004 39.1248 25.3875 39.1236 23.5553C39.1236 15.87 32.5171 9.34921 24.0008 9.34921C15.4834 9.34921 8.87803 15.87 8.87803 23.5553C8.87803 25.4348 9.26683 27.2328 9.97873 28.8823C10.5526 30.2141 10.262 31.8406 9.05783 32.6487L8.16923 33.2424C6.73713 34.2021 4.77403 33.833 4.02973 32.2776C2.72453 29.5552 2.04753 26.5744 2.04883 23.5553Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPodcast);
export default __webpack_public_path__ + "static/media/User-Podcast.856cfbec675bff28c32e562b94c41387.svg";
export { ForwardRef as ReactComponent };